interface Props {
  plotX: number;
  plotY: number;
  plotW: number;
  plotH: number;
}

export function SvgDefs({ plotX, plotY, plotW, plotH }: Props) {
  return (
    <defs>
      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="4" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="textshadow">
        <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor="#000" floodOpacity="0.8" />
      </filter>
      <filter id="innerGlow" x="-5%" y="-5%" width="110%" height="110%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="8" result="blur" />
        <feOffset dx="0" dy="0" />
        <feComposite in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feFlood floodColor="#000" floodOpacity="0.3" />
        <feComposite operator="in" in2="blur" />
        <feComposite operator="over" in2="SourceGraphic" />
      </filter>
      <clipPath id="plotClip">
        <rect x={plotX} y={plotY} width={plotW} height={plotH} rx={6} />
      </clipPath>
    </defs>
  );
}
